import { AxiosInstance } from 'axios';
import {
  TerminalContactEndpoints,
  SearchTerminalContactsRequest,
  SearchTerminalContactsResponse,
  CreateTerminalContactRequest,
  CreateTerminalContactResponse,
  UpdateTerminalContactRequest,
  UpdateTerminalContactResponse,
  DeleteTerminalContactRequest,
} from './TerminalContactServices.types';

export class TerminalContactServices implements TerminalContactEndpoints {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(request: SearchTerminalContactsRequest) {
    return this.instance.get<SearchTerminalContactsResponse>(
      `/terminals/${request.routeParams.terminalGuid}/contacts`,
      {
        params: request.queryParams,
      },
    );
  }

  create(request: CreateTerminalContactRequest) {
    return this.instance.post<CreateTerminalContactResponse>(
      `/terminals/${request.routeParams.terminalGuid}/contacts`,
      request.body,
    );
  }

  update(request: UpdateTerminalContactRequest) {
    return this.instance.put<UpdateTerminalContactResponse>(
      `/terminals/${request.routeParams.terminalId}/contacts/${request.routeParams.contactId}`,
      request.body,
    );
  }

  delete(request: DeleteTerminalContactRequest) {
    return this.instance.delete<void>(
      `/terminals/${request.routeParams.terminalId}/contacts/${request.routeParams.contactId}`,
    );
  }
}
